<template>
  <div class="information-student">
    <h4 class="title-section">{{ title }}</h4>
    <div class="box p-grid">
        <div class="p-col-12 p-sm-2 p-md-2 p-lg-2 p-xl-2">
            <div class="item picture">
                <!-- <label for="">SBD:</label> -->
                <!-- <h3>{{informationsData.code}}</h3> -->
                <img :src="informationsData.studentPicture" alt="">
            </div>
        </div>
        <div class="left p-col-12 p-sm-4 p-md-4 p-lg-4 p-xl-4">
            <div class="item">
                <label for="">Họ và tên:</label>
                <h3>{{informationsData.studentName}}</h3>
            </div>
            <div class="item">
                <label for="">Lớp ở trường:</label>
                <h3>{{informationsData.classAtSchool}}</h3>
            </div>
            <div class="item">
                <label for="">Điện thoại:</label>
                <h3>{{informationsData.studentPhone}}</h3>
            </div>
            <div class="item">
                <label for="">Điện thoại phụ huynh:</label>
                <h3>{{informationsData.parentPhone}}</h3>
            </div>
        </div>
        <div class="right p-col-12 p-sm-4 p-md-4 p-lg-4 p-xl-4">
            <div class="item">
                <label for="">Mã học sinh:</label>
                <h3>{{informationsData.studentCode}}</h3>
            </div>
            <div class="item">
                <label for="">Trường:</label>
                <h3>{{informationsData.schoolName}}</h3>
            </div>
            <div class="item">
                <label for="">Ngày sinh:</label>
                <h3>{{informationsData.studentBirth}}</h3>
            </div>
            <div class="item">
                <label for="">Tên phụ huynh:</label>
                <h3>{{informationsData.parentName}}</h3>
            </div>
        </div>
        <div class="right-code p-col-12 p-sm-2 p-md-2 p-lg-2 p-xl-2">
            <div class="item">
                <label for="">SBD:</label>
                <h3>{{informationsData.code}}</h3>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InformationStudents',
  props: ['informationsData','title'],
  components: {},
  data() {
    return {}
  },
  watch: {
  },
  created() {
  },
  methods: {
    
  }
}
</script>

<style>
</style>